import React from 'react'

import SupportDropdown from './Dropdown'
import IconButton from 'components/Utils/IconButton'
import { QuestionIcon } from 'components/Utils/Icons'

export default function MetaSupport(props) {
  return (
    <div className="center-text">
      <SupportDropdown
        {...props}
        className="text-align-left"
        placement="custom"
        placementCustomStyle={{
          top: 'auto',
          right: '100%',
          bottom: '6px',
          left: 'auto',
        }}
        renderButtonFn={({ getButtonProps }) => (
          <IconButton tooltip="Support and help center" {...getButtonProps()}>
            <QuestionIcon size={16} />
          </IconButton>
        )}
      />
    </div>
  )
}
